module.exports = __webpack_public_path__ + "img/03—04—WLAN scanner.8fc4da5a.jpg";